import * as React from 'react';

const AssortmentsPremiumComplexIllustrationSvg = (
    props: React.SVGProps<SVGSVGElement>,
) => (
    <svg
        className="assortments-premium-complex-illustration_svg__eds-illustration-assortments-premium-complex"
        viewBox="0 0 472 340"
        {...props}
    >
        <path
            d="M124.76 118.48l-14.23-23.64c-17-.5-34.85 15-36.63 16.62a.31.31 0 00-.07.32c.37 1.41-3 2.85-2.12 4.57.44.85 4.5 0 5.07 1.1.48.92-2.56 3.75-2 4.78s4.56.09 5.08 1.09-2.52 3.81-2 4.78 4.58.12 5.08 1.06-2.47 3.88-2 4.79c.58 1.08 4.63.16 5.09 1 .55 1-1 2.77-1.95 3.9a.35.35 0 00.41.55l6.32-2.74c9.06-3.59 35.03-14.24 33.95-18.18z"
            fill="#f6682f"
        />
        <path
            d="M64.44 235.21s2.72-5.06 1.48-7.49-5.36-5.5-7.22-10.11c-3-7.47 11.52-15 17.78-5.51s4.66 15.36-2.95 15.49a32.14 32.14 0 002.55 6.63z"
            fill="#6d717a"
        />
        <ellipse
            cx={57.5}
            cy={210.47}
            rx={5.23}
            ry={4.46}
            transform="rotate(-60.88 57.492 210.466)"
            fill="#6d717a"
        />
        <ellipse
            cx={51.25}
            cy={208.35}
            rx={2.56}
            ry={2.18}
            transform="rotate(-81.97 51.242 208.356)"
            fill="#6d717a"
        />
        <path
            d="M64.43 218.49c-.77-1.9 2.74-3.87 4.1-.5 2.57-1 5-4.42 7.77-6.14-6.34-9.09-20.58-1.64-17.6 5.76 1.86 4.61 6 7.67 7.22 10.11a3.64 3.64 0 01.32 1.77s1.65-5.54.41-8.62c-.59-1.47-1.65-.99-2.22-2.38z"
            fill="#6d717a"
        />
        <path
            d="M80.93 229.75l2.43 12a197.71 197.71 0 0018.48-10.31l-1.36-10c-5.91 2.83-13.63 6.11-19.55 8.31z"
            fill="#9b9ea7"
        />
        <path
            d="M73.5 276.35H50c-4.31 15 8.66 44.4 8.66 44.4s-19.4-2.66-33-4l-2.65 10c9.46 0 45.5 11 50.93 11 3.23-12.24-.44-61.4-.44-61.4z"
            fill="#282c35"
        />
        <path
            d="M106.4 326.06c.91-5.82 6.13-32.59 9-47.38a7.4 7.4 0 00-8.09-8.77L50 276.35s.32 19.85 16.77 19.85a86.42 86.42 0 0031.27-6.43s-3.81 12.62-2.25 38.1h10.61a5.68 5.68 0 010-1.81zM128.74 206.66a219.91 219.91 0 01-28.26 14.8l1.36 10c14.67-9.35 28.75-20.06 28.75-20.06zM55.8 229.84l-3.69 2.95a1 1 0 00-.29 1.19l15 33.06c2.73 5.56 6.59 2.7 6.59 2.7l-16-39.5a1 1 0 00-1.61-.4zM138.35 327.26s8 10.42 13.5 10.42h4.55a22.75 22.75 0 01-5.38-7.5s20.48-15.14 34.85-28.8a28.27 28.27 0 006-8.39h-18.94c-8.51 3.12-26.93 26.24-34.58 34.27z"
            fill="#282c35"
        />
        <path
            d="M195.45 259.69l-22.53 21V293h18.91c6.86-14.33 3.62-33.31 3.62-33.31z"
            fill="#9b9ea7"
        />
        <path
            d="M233.44 273.67c3.77-14-7.21-16.49-7.21-16.49l-25.76-6.83-22.2 8c1.44 13.9 37.54 16 37.54 16h17.45z"
            fill="#6d717a"
        />
        <path
            d="M235.8 318.08s-12.7 5.25-21.42 8c0 0-5.43-34.82 1.44-51.75h17.45c-4 14.72-10.62 32.43-10.91 37.7-.67 6.47 12.71 2.61 13.44 6.05z"
            fill="#282c35"
        />
        <path
            d="M243.85 236.61c-12.46 0-10.54 54-24.92 54s-31 16.61-19.81 40.57c7.67-18.21 44.72-13.89 44.72-43.28z"
            fill="#ffa71a"
        />
        <path
            d="M74.46 179.79c-1.32.14-.8 1.4-.16 1.37 7.65-.38 35.22 3.89 53.21 27.88s14.93 51.89 11.83 58.89c-.43 1 1 1.64 1.47.32 2.12-6.2 11.18-32-10.68-61.18S81 179.1 74.46 179.79z"
            fill="#f6682f"
        />
        <path
            d="M127.51 209a68.3 68.3 0 015.55 8.71l2.71-2a80.36 80.36 0 00-12.36-16.49l-2.71 2a68.3 68.3 0 016.81 7.78z"
            fill="#9b9ea7"
        />
        <path
            d="M53.41 306.4c14.82 0 26.16-25.75 33.35-25.75 3.83 0 3 3.23 7 3.87s13.56-15.15 13.56-15.15l-57.33 7s-4.67 11.79 3.42 30.03z"
            fill="#d2d6df"
        />
        <path
            fill="none"
            stroke="#0af5b8"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M200.48 250.35l-6.39-1.44"
        />
        <path
            d="M50 276.35c5.44-16.24 11.88-27 13.11-40.78l17.8-5.82c9.94 24.68-3 25.15-5.36 38.12L74 273.65z"
            fill="#d2d6df"
        />
        <path
            d="M125.66 210.35l-.67-5c-.21-1.48.58-.94 1.31.79l.86 2.7zM129.74 206.66a5.26 5.26 0 00-.74 4.23c.72 2.14 4.37-.05 4.37-.05s-1.16-3.61-3.63-4.18zM52.54 232.95a.5.5 0 01-.46-.29l-1.39-3.08a.5.5 0 01.91-.41l1.4 3.07a.5.5 0 01-.25.66.49.49 0 01-.21.05zM55.65 230.46a.5.5 0 01-.46-.29l-1.64-3.65a.5.5 0 01.91-.41l1.64 3.65a.5.5 0 01-.25.66.49.49 0 01-.2.04z"
            fill="#282c35"
        />
        <path
            d="M16.32 316l-5.75 21.71c4.24 0 8.63-11 12.46-11l2.65-10c-3.68-.36-7.03-.64-9.36-.71zM121.58 337.68c-1.76-3.93-14.18-3.58-15.18-9.83H95.8c.19 3.09.45 6.36.81 9.83z"
            fill="#9b9ea7"
        />
        <path
            fill="#f6682f"
            d="M51.84 230.91l-2.35-1.54-1.97-4.78 1.92.9.82-2.18 1.98 4.85-.4 2.75z"
        />
        <path
            d="M138.54 286l-30.18 50.21a1 1 0 00.86 1.52h60.36a1 1 0 00.86-1.52L140.25 286a1 1 0 00-1.71 0zM84.87 236.44a1 1 0 01-.54-1.84l50.79-32.24a1 1 0 011.07 1.69L85.4 236.29a1 1 0 01-.53.15z"
            fill="#6d717a"
        />
        <path
            d="M134 200.61l1.65 2.6 1.63 2.56 4.82-6.5a.14.14 0 00-.14-.22z"
            fill="#f6682f"
        />
        <path
            d="M181.74 227.06c-3.46-19 1.48-23.7 9-28 2.88-2.16 4-3.35 4-5.83 0-4.23-4-8.47-4-12.54 0-10.3 18.61-14.62 20.21.16s-3.43 16.21-8.47 15.09l.42 4.58 20.7-4.52s4.91 11.14-12 16.89l-11.14 37.5s19.89 4.31 25.76 6.83l-53.31 23.48.36-19.65c0-16.16 9.19-19.09 10-27.8l10.82-6.25z"
            fill="#282c35"
        />
        <path
            d="M202.9 200.55l-.42-4.58c5 1.12 10.06-.32 8.47-15.09s-20.21-10.46-20.21-.16c0 4.07 4 8.31 4 12.54 0 2.48-1.12 3.67-4 5.83a35 35 0 00-4.07 2.66s9.85 7 16.09 5.95.14-7.15.14-7.15z"
            fill="#9b9ea7"
        />
        <path
            d="M196.41 181.51c0-2.16 3.67-2.64 3.67.8 2.24 0 6.67-2.67 10.68-2.67-2.48-13.29-20-8.93-20 1.07 0 4.07 4 8.31 4 12.54 0-5.19 3.28-5 3.28-8.15-.04-1.48-1.65-1.46-1.63-3.59z"
            fill="#282c35"
        />
        <path
            d="M223.6 196c-3.35-11.62-12.52-39.76-12.52-39.76s-1.8-5.91-5.39-7.69l3 10.48s4.51 26.57 5.69 39z"
            fill="#6d717a"
        />
        <path
            d="M230.79 241.83a1 1 0 01-1-.74L169.6 20.57a1 1 0 111.93-.53l60.23 220.52a1 1 0 01-.7 1.23 1 1 0 01-.27.04z"
            fill="#282c35"
        />
        <path
            d="M181.74 227.06a27.46 27.46 0 004.19 11.78c11.73 17.33 43.09-8 44.85-13.26s-4.84-6.12-4.84-6.12l.84 2.93s-13.1 11.22-30.25 11.22l-2.44-6.61z"
            fill="#9b9ea7"
        />
        <path
            d="M198.23 192a5.87 5.87 0 004.25 4l.28 3.11a9.38 9.38 0 01-4.53-7.11zM76.48 212.09l-.18-.25c-2.75 1.72-5.2 5.1-7.77 6.14-1.36-3.37-4.87-1.4-4.1.5.56 1.39 1.63.92 2.22 2.38 1.24 3.07-.41 8.62-.41 8.62a16.18 16.18 0 01-1.8 5.73s8 8.81 12.16 8c4.51-.88-1.84-11.89-1.86-11.92a32.11 32.11 0 01-1.21-3.7c7.61-.14 9.2-6.01 2.95-15.5z"
            fill="#282c35"
        />
        <path
            d="M74 273.65l-13.63 1.45s10.93-3.64 14.78-5.72z"
            fill="#9b9ea7"
        />
        <path
            d="M76.16 181.13s-2.16 53.13 3.48 60.64c6.18 8.24 60.08 25.58 60.08 25.58"
            fill="none"
            stroke="#45494e"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M88 233.46l-2.11 4.68-8.24 5 1.1-3.82-4.25-.88 8.37-5 5.08-.06a.07.07 0 01.05.08z"
            fill="#f6682f"
        />
        <path
            d="M63.13 235.57c-10.28 3.34-22.65 11.26-28.13 19.37l12.53 1.31 12.86-5.77s3.26-10.07 2.74-14.91z"
            fill="#d2d6df"
        />
        <path
            d="M60 236.71c2.3 5.36 10.87 20.39 16.69 27.29 0 0-.67 2-1.13 3.88 0 0-13.12-15.5-18.67-29.83z"
            fill="#6d717a"
        />
        <path
            d="M35 254.94s-8.89 17 7.85 11.26a64.21 64.21 0 0030-22l8-1.34a.46.46 0 00.34-.64l-1.73-3.85A2.88 2.88 0 0075.6 237S49.25 256.78 35 254.94zM98.78 114.11c2.58 4.26 24.3.78 26 4.37L113 97.76s-18.25 5.04-14.22 16.35z"
            fill="#282c35"
        />
        <path
            d="M149 90.72c4.14 7.83-54.65 12.42-50.17 23.4 0 0-9.64-11.94-16.13-31.11a1 1 0 01.3-1.09c3.24-2.75 21.84-17.43 54.48-21.89z"
            fill="#bf4c28"
        />
        <circle cx={170.57} cy={19.6} r={2.53} fill="#ffa71a" />
        <path
            d="M123.12 82.36c2.54 4.54 23.37 4 25.83 8.35L137.42 60S122 77.94 123.12 82.36z"
            fill="#282c35"
        />
        <path
            d="M106.07 45.09c1.62 4.21 10.18 26.15 17.05 37.27 0 0-.05-16 60.4-17.6a1.07 1.07 0 001-.87c.4-2.59 5.79-4.17 5.31-6-.52-2-7.33-.86-8-3.33s5.45-4.51 5.3-6.68-6.8-.66-7.73-2.42 5.71-4.9 5.26-6.84-6.8-.67-7.69-2.24 4.41-4.55 4.11-6.87-5.93.06-6.47-2l-.54-2s-39.52-2.61-67.71 18.4a1 1 0 00-.29 1.18z"
            fill="#f6682f"
        />
        <path
            d="M308.3 130.55c-12.46 5.11-10.06 21.72 2.88 16.93 15.29-5.67 26.41-16.15 33.46-24.72a58.39 58.39 0 01-3.94-7.45c-13.43 9.28-32.4 15.24-32.4 15.24z"
            fill="#282c35"
        />
        <path
            d="M322.43 337.68c6.47 0 39.53-47.56 52-47.56 8 0-16.29 35.7-9.34 35.7s37.86-44.56 46.24-44.56-24.92 47.68-18.69 47.68 17.49-11.74 23.72-11.74-12.7 20.49-7.19 20.49z"
            fill="#edeff5"
        />
        <path
            d="M311.7 94.79s-3.48-13.3-12.58-13.3-15.69 16.17-29 16.17c-12.84 0-26.91-18.32-41.45-4.58a1 1 0 00.57 1.7c18.07 1.91 16 28.27 30.71 27.92 15.21-.36 32.46-29.85 40.85-29.85 4.79 0 8.08 4.19 8.08 4.19z"
            fill="#f6682f"
        />
        <path
            d="M307.34 109.71s-6-10.39 4.91-16.05c7.19-3.71 15.94.92 15.76 6.51z"
            fill="#9b9ea7"
        />
        <path
            d="M331.42 110.91c1-18.93-24.08-19-24.08-1.2a38.6 38.6 0 001.6 10.39l-3 3 15.62 5v-5s9.89 2.26 9.86-12.19z"
            fill="#d2d6df"
        />
        <path
            d="M331.78 103l-17.13 5.44a2.51 2.51 0 000 4.93l17.13 4.08c3.91-8.22 0-14.45 0-14.45z"
            fill="#6d717a"
        />
        <path
            d="M408.39 11.25a8.46 8.46 0 00-1.83 2.17l-47.26 79 1.82 2.81 3.33.41L416 19.31a8.46 8.46 0 001.15-2.59l3.61-14.36a.63.63 0 00-1-.64z"
            fill="#f6682f"
        />
        <path
            fill="#9b9ea7"
            d="M349.818 88.868l1.273-2.034 22.31 13.963-1.273 2.034zM350.432 106.973l7.958-12.715 5.145 3.22-7.427 11.867a1 1 0 01-1.378.317l-4.298-2.69z"
        />
        <path
            d="M361.7 100.38s-3.65.77-5 2.69c-2 2.76 2.28 4 2.28 4s4.38-4.86 3.37-7.63zM355.68 97.95c-1.68.84-4 2.16-4 2.16l-2.12 7.46a44 44 0 01-8.84 7.76 58.39 58.39 0 003.94 7.45 82.5 82.5 0 009.28-13.62s1-5.35-.31-7.27l2.53-2.82c.59-.55 1.26-1.99-.48-1.12z"
            fill="#45494e"
        />
        <path
            d="M376.58 117.46a13.09 13.09 0 00-15.72-5.12c-10.54 3.59-8.34 18-14.33 25.89-4.58 6-18 7.08-18.46 20.26s-.07 23.54-6 31.07zM378.9 194.13l44.89-13a5.67 5.67 0 014.51.59l28.86 17.41v15.46a1 1 0 01-1.2 1l-11-2.3a1 1 0 01-.71-1.38l3.34-7.65-20.45-10.39-46.72 18.38zM310.06 242.52s18.44 26.19-14 54.14l12.67 30.59 8.19 10.42H301l-18.43-41.61v-44.43zM278.11 337.68h16.77l-7.91-10.42h-12.61l3.75 10.42zM390.73 247.73l5.91 12.52a1 1 0 001.59.3l8.33-7.92-5.75-9-9.45 2.72a1 1 0 00-.63 1.38z"
            fill="#282c35"
        />
        <path
            d="M427.46 204.05l-42.47-8c0-8.46-10.25-26.24-10.25-40.93 7.13 1.62 20.45 7 29.71 9.26 13.26 3.91 16-12.18 12.5-14.58l-36.54-30.55c-.72-6-6.35-17.25-7.43-14.62s-3 14.62-3 14.62c-15.26 0-31.76 82.78-91.34 87.61 0 0-34.29-2.56-34.29 33.54 0 29.39 31 35.78 31 35.78-1.29 4.07-7.49 17.33-9.82 22.25a5 5 0 00-.18 3.82l9 25H287l-8.15-26.83s7.19-8.63 18.69-21.32 4.55-23.48 4.55-23.48c12.31-20.21 64.85-24.29 76.83-40.79 6.3 0 36.92 2 36.92 2l-15 26.75 5.75 9a217.05 217.05 0 0025-40.68 5.64 5.64 0 00-4.13-7.85z"
            fill="#ffa71a"
        />
        <path
            d="M385.21 199.08c0-9.9-4.23-16.13-5.69-22-18.63 3.59-46.78-4.55-46.78-4.55-40 43.29-47 26.59-69.72 35-30 15.2-17.66 49.93-14.71 57.14a.56.56 0 001 0l1.66-4.75a6.13 6.13 0 017.84-3.72l8.29 3a6.13 6.13 0 007.84-3.72l3-8.29a6.13 6.13 0 017.84-3.72l8.29 3a6.13 6.13 0 007.84-3.72l3-8.29a6.13 6.13 0 017.84-3.72l8.29 3a6.13 6.13 0 007.84-3.72l3-8.29a6.13 6.13 0 017.84-3.72l8.29 3a6.13 6.13 0 007.84-3.72l3-8.29a6.13 6.13 0 017.84-3.72l8.29 3c8.5 1.89 10.23-9.2 10.23-9.2z"
            fill="#6d717a"
        />
        <path
            d="M380.42 119.29l-4.23 16.93c-1.12 6.39 3 1.84 7.35-1.36 4.09-3 7-2 6.91 11.68a3.57 3.57 0 002.16 3.31L418 160.68s5-5.74-1.08-10.84zM382.09 198.07a6.06 6.06 0 00-3.35 3.93c-.54 1.35-1 2.62-2.82 3.38s-3 .25-4.39-.29a6.06 6.06 0 00-5.16-.28l-.25.13.41.12 1.11.4a5.65 5.65 0 013.51.56 5.83 5.83 0 008.51-3.64c.54-1.35 1-2.62 2.82-3.38a4.24 4.24 0 012.72-.27v-1a5.21 5.21 0 00-3.11.34zM298.51 200.63a6 6 0 00.85-.29 5.7 5.7 0 001.16-.67q-1.03.52-2.01.96zM355.81 211.81a5.82 5.82 0 00-8.51 3.64c-.54 1.35-1 2.62-2.82 3.38a4.68 4.68 0 01-1.1.32l1.57.56a6.09 6.09 0 003.28-3.89c.54-1.35 1-2.62 2.82-3.38s3-.25 4.39.29a12.63 12.63 0 001.63.57l.34-.95a11.11 11.11 0 01-1.6-.54zM252.2 220.54a6.06 6.06 0 003.35-3.93c.54-1.35 1-2.62 2.82-3.38s3-.25 4.39.29a5.82 5.82 0 008.51-3.65c.54-1.35 1-2.62 2.82-3.38a5.11 5.11 0 014.39.29 6.05 6.05 0 005.16.28 5.52 5.52 0 003-3.17l-1.17.13a4.31 4.31 0 01-2.26 2.12c-1.77.76-3 .25-4.39-.29a5.82 5.82 0 00-8.51 3.65c-.54 1.35-1 2.62-2.82 3.38s-3 .25-4.39-.29a5.82 5.82 0 00-8.51 3.64c-.54 1.35-1 2.62-2.82 3.38a4.27 4.27 0 01-3 .21q-.28.44-.55.88a5.34 5.34 0 003.98-.16zM315.08 193.61a6.06 6.06 0 003.35-3.93c.54-1.35 1-2.62 2.82-3.38a5.1 5.1 0 014.39.29 5.82 5.82 0 008.51-3.65c.54-1.35 1-2.62 2.82-3.38a5.11 5.11 0 014.39.29 5.82 5.82 0 008.5-3.64l-1-.17a4.9 4.9 0 01-2.73 3.17c-1.77.76-3 .25-4.39-.29a5.82 5.82 0 00-8.51 3.64c-.54 1.35-1 2.62-2.82 3.38a5.1 5.1 0 01-4.39-.29 5.83 5.83 0 00-8.51 3.64c-.54 1.35-1 2.62-2.82 3.38a4.43 4.43 0 01-3.43.07l-.94.72a5.74 5.74 0 004.76.15zM246.18 228.19a5.1 5.1 0 014.39.29 5.83 5.83 0 008.51-3.64c.54-1.35 1-2.62 2.82-3.38a5.11 5.11 0 014.39.29 5.82 5.82 0 008.51-3.65c.54-1.35 1-2.62 2.82-3.38a5.11 5.11 0 014.38.28 5.83 5.83 0 008.51-3.64c.54-1.35 1-2.62 2.82-3.38s3-.25 4.39.29a5.83 5.83 0 008.51-3.65c.54-1.35 1-2.62 2.82-3.38s3-.25 4.39.29a5.82 5.82 0 008.56-3.63c.54-1.35 1-2.62 2.82-3.38s3-.25 4.39.29a5.82 5.82 0 008.51-3.65c.54-1.35 1-2.62 2.82-3.38s3-.25 4.39.29a5.82 5.82 0 008.51-3.64c.54-1.35 1-2.62 2.82-3.38s3-.25 4.39.29a6.05 6.05 0 005.16.28 5.85 5.85 0 003.26-3.69h-1.08a4.61 4.61 0 01-2.57 2.77c-1.77.76-3 .25-4.39-.29a5.82 5.82 0 00-8.51 3.64c-.54 1.35-1 2.62-2.82 3.38s-3 .25-4.39-.29a5.82 5.82 0 00-8.51 3.64c-.54 1.35-1 2.62-2.82 3.38s-3 .25-4.39-.29a5.83 5.83 0 00-8.51 3.64c-.54 1.35-1 2.62-2.82 3.38s-3 .25-4.39-.29a5.83 5.83 0 00-8.51 3.65c-.54 1.35-1 2.62-2.82 3.38s-3 .25-4.39-.29a5.83 5.83 0 00-8.51 3.65c-.54 1.35-1 2.62-2.82 3.38s-3 .25-4.39-.29a5.82 5.82 0 00-8.51 3.65c-.54 1.35-1 2.62-2.82 3.38s-3 .25-4.39-.29a5.82 5.82 0 00-8.51 3.64c-.54 1.35-1 2.62-2.82 3.38s-3 .25-4.39-.29a5.75 5.75 0 00-5.76 0c-.17.53-.33 1.07-.47 1.61a4.41 4.41 0 011.42-.97zM327.27 178.65a6 6 0 003.34-3.9q-2 2.17-4 4.12a6 6 0 00.66-.22zM295.54 246.62a6.78 6.78 0 00-1.59-.36h.12a6.13 6.13 0 001.47.36zM326.3 232.94a5.26 5.26 0 00-3.56.27 5.8 5.8 0 00-1 .53 6.12 6.12 0 004.56-.8zM364.48 188.64a5.82 5.82 0 00-8.51 3.64c-.54 1.35-1 2.62-2.82 3.38s-3 .25-4.39-.29a5.82 5.82 0 00-8.51 3.64c-.54 1.35-1 2.62-2.82 3.38s-3 .25-4.39-.29a5.83 5.83 0 00-8.51 3.64c-.54 1.35-1 2.62-2.82 3.38s-3 .25-4.39-.29a5.83 5.83 0 00-8.51 3.65c-.54 1.35-1 2.62-2.82 3.38s-3 .25-4.39-.29a5.83 5.83 0 00-8.51 3.65c-.54 1.35-1 2.62-2.82 3.38s-3 .25-4.39-.29a5.83 5.83 0 00-8.51 3.65c-.54 1.35-1 2.62-2.82 3.38s-3 .25-4.39-.29a5.82 5.82 0 00-8.51 3.64c-.54 1.35-1 2.62-2.82 3.38s-3 .25-4.39-.29a5.82 5.82 0 00-8.51 3.65 5.2 5.2 0 01-2.6 3.27q0 .54.06 1.07h.12a6.06 6.06 0 003.35-3.93c.54-1.35 1-2.62 2.82-3.38a5.1 5.1 0 014.39.29 5.83 5.83 0 008.51-3.64c.54-1.35 1-2.62 2.82-3.38a5.11 5.11 0 014.39.29 5.83 5.83 0 008.51-3.65c.54-1.35 1-2.62 2.82-3.38a5.11 5.11 0 014.39.29 5.82 5.82 0 008.51-3.64c.54-1.35 1-2.62 2.82-3.38a5.11 5.11 0 014.39.29 5.83 5.83 0 008.51-3.65c.54-1.35 1-2.62 2.82-3.38s3-.25 4.39.29a5.82 5.82 0 008.51-3.64c.54-1.35 1-2.62 2.82-3.38s3-.25 4.39.29a5.82 5.82 0 008.51-3.65c.54-1.35 1-2.62 2.82-3.38a5.11 5.11 0 014.39.29 5.82 5.82 0 008.51-3.64c.54-1.35 1-2.62 2.82-3.38s3-.25 4.39.29a5.82 5.82 0 008.51-3.64c.54-1.35 1-2.62 2.82-3.38s3-.25 4.39.29a11.12 11.12 0 001.93.63l-.44-1.14c-.37-.12-.74-.26-1.11-.41a5.82 5.82 0 00-8.51 3.64c-.54 1.35-1 2.62-2.82 3.38s-3.05.2-4.4-.34zM378.56 189.85a6.06 6.06 0 00-3.35 3.93c-.54 1.35-1 2.62-2.82 3.38s-3 .25-4.39-.29a5.82 5.82 0 00-8.51 3.64c-.54 1.35-1 2.62-2.82 3.38s-3 .25-4.39-.29a5.82 5.82 0 00-8.51 3.64c-.54 1.35-1 2.62-2.82 3.38s-3 .25-4.39-.29a5.83 5.83 0 00-8.51 3.64c-.54 1.35-1 2.62-2.82 3.38a5.11 5.11 0 01-4.39-.29 5.83 5.83 0 00-8.51 3.65c-.54 1.35-1 2.62-2.82 3.38s-3 .25-4.39-.29a5.83 5.83 0 00-8.51 3.65c-.54 1.35-1 2.62-2.82 3.38s-3 .25-4.39-.29a5.82 5.82 0 00-8.51 3.64c-.54 1.35-1 2.62-2.82 3.38s-3 .25-4.39-.29a5.82 5.82 0 00-8.51 3.64c-.54 1.35-1 2.62-2.82 3.38s-3 .25-4.39-.29a5.82 5.82 0 00-8.51 3.65c-.54 1.35-1 2.62-2.82 3.38a4.26 4.26 0 01-2.25.35q.1.51.2 1a5.29 5.29 0 002.44-.45 6.06 6.06 0 003.38-3.93c.54-1.35 1-2.62 2.82-3.38a5.11 5.11 0 014.39.29 5.83 5.83 0 008.51-3.64c.54-1.35 1-2.62 2.82-3.38s3-.25 4.39.29a5.83 5.83 0 008.51-3.65c.54-1.35 1-2.62 2.82-3.38a5.1 5.1 0 014.39.29 5.82 5.82 0 008.51-3.64c.54-1.35 1-2.62 2.82-3.38s3-.25 4.39.29a5.83 5.83 0 008.51-3.65c.54-1.35 1-2.62 2.82-3.38a5.11 5.11 0 014.39.29 5.82 5.82 0 008.51-3.64c.54-1.35 1-2.62 2.82-3.38s3-.25 4.39.29a5.82 5.82 0 008.51-3.64c.54-1.35 1-2.62 2.82-3.38a5.1 5.1 0 014.39.29 5.82 5.82 0 008.51-3.64c.54-1.35 1-2.62 2.82-3.38a5.11 5.11 0 014.39.29 5.82 5.82 0 008.51-3.64c.54-1.35 1-2.62 2.82-3.38s3-.25 4.39.29c.32.13.64.26 1 .37q-.14-.59-.29-1.17l-.32-.13a6.06 6.06 0 00-5.2-.27zM276.85 246.41c.38.15.77.3 1.18.44a6.16 6.16 0 01.44-.91c-.42-.12-.83-.28-1.25-.45a5.82 5.82 0 00-8.51 3.64c-.54 1.35-1 2.62-2.82 3.38s-3 .25-4.39-.29a5.82 5.82 0 00-8.51 3.65c-.54 1.35-1 2.62-2.82 3.38a4.63 4.63 0 01-3.81-.06c.13.41.26.8.38 1.18a5.3 5.3 0 003.82-.2c.15-.06.27-.14.4-.21v-.13a6.1 6.1 0 012.78-3.28l.12-.31c.54-1.35 1-2.62 2.82-3.38a5.11 5.11 0 014.39.29 5.83 5.83 0 008.51-3.64c.54-1.35 1-2.62 2.82-3.38s3.1-.26 4.45.28zM307 231.43a5.26 5.26 0 00-3.47.3 6.06 6.06 0 00-3.35 3.93c-.54 1.35-1 2.62-2.82 3.38a5.1 5.1 0 01-4.39-.29 5.82 5.82 0 00-8.51 3.65l-.25.61a6.08 6.08 0 011 .16l.16-.4c.54-1.35 1-2.62 2.82-3.38a5.11 5.11 0 014.39.29 5.82 5.82 0 008.51-3.65c.54-1.35 1-2.62 2.82-3.38a4.26 4.26 0 012.14-.36 6.11 6.11 0 01.95-.86zM328.77 225.57c-1.77.76-3 .25-4.39-.29a5.83 5.83 0 00-8.51 3.65 7.11 7.11 0 01-1.29 2.33l1 .36a9 9 0 001.22-2.31 5.1 5.1 0 012.82-3.38c1.77-.76 3-.25 4.39.29a6.05 6.05 0 005.16.28 5.73 5.73 0 001.06-.6l1-2.9a4.5 4.5 0 01-2.46 2.57z"
            fill="#45494e"
        />
        <path
            d="M376 155.46l-13.91-4.06s-3.71 25.64 1.8 48.89l21.32-1.21c0-12.7-9.21-27.65-9.21-43.62z"
            fill="#9b9ea7"
        />
        <path
            d="M410.65 157.42s-24.92 13.42-44.08 13.42-43.37-9.19-43.37-9.19 10.43 19.52 24.57 19.52c7.55 0 9.63-3.56 13.1-3.56S367.58 184 372 184s9.4-7.69 12.87-7.93 4.67 5.27 10.78 4.19 15-22.84 15-22.84z"
            fill="#282c35"
        />
        <path
            d="M362.09 226s-10.27 1.23-16.41-2c-2.94-1.53-1.27-30.31-.49-41.72a5.29 5.29 0 00-4.47-5.59c-6.76-1-21.07-1.21-44.39.35-11.66.8-28.27 2.08-28.27 2.08s-10.94 28.55 18.53 24.8 40.65-14.42 40.65-14.42l7.51 46.41s19.99-6.42 27.34-9.91z"
            fill="#d2d6df"
        />
        <path
            d="M268 179.11l36.56-2.62 11.52-25.38h-33.29c-8.45 14.14-14.79 28-14.79 28z"
            fill="#d2d6df"
        />
        <path
            d="M321.52 128.16l-15.62-5c-7.61 4.35-16.1 16.26-23.11 28h36.77a53.8 53.8 0 001.96-23z"
            fill="#9b9ea7"
        />
        <path
            d="M288.51 180.39s-43.7 64.93-36.75 64.93 50.31-64.93 50.31-64.93zM292.09 142.49s9.43-14.33 17.29-14.33 9.63 9.58 6.75 14.33z"
            fill="#282c35"
        />
        <path
            d="M333.43 227.86l6.84 2.77 5.4-6.64s5.33 3 16.41 2c0 0-18.14 7.44-27.35 9.94 0-.02-1.07-2.11-1.3-8.07z"
            fill="#6d717a"
        />
        <path
            d="M316.12 142.49s-21.8 31.16-35.55 43.07l-10.47-1.71 24.67-41.37zM345.18 182.28h-9.48l4.57 48.36 5.4-6.64-.49-41.72"
            fill="#282c35"
        />
        <path
            fill="#f6682f"
            d="M54.45 227.59l-2.64-1.73-2.23-5.38 2.17 1.01.92-2.45 2.23 5.45-.45 3.1zM311.69 142.62c-11.2-8.17-23.95-11.23-28.8-12.15a3.19 3.19 0 00-3.18 1.26l-15 20.61c-22.84 31.31-10.39 69-10.39 69s39.67.35 62.5-31l15-20.61a3.19 3.19 0 00.23-3.41c-2.35-4.32-9.16-15.53-20.36-23.7z"
        />
        <circle
            cx={293.14}
            cy={167.74}
            r={14}
            transform="rotate(-8.98 293.062 167.738)"
            fill="#ffa71a"
        />
        <path
            d="M471 340l-470-.07a1.13 1.13 0 010-2.24l470 .07a1.13 1.13 0 010 2.24z"
            fill="#282c35"
        />
    </svg>
);

AssortmentsPremiumComplexIllustrationSvg.displayName =
    'AssortmentsPremiumComplexIllustrationSvg';
export default AssortmentsPremiumComplexIllustrationSvg;
